import { inject, Injectable } from '@angular/core';
import { ExtractedLocationStoreService } from './overlay/extracted-location-store.service';
import { OcrHighlightService } from './overlay/ocr-highlight.service';
import { PersistDataService } from './app-state/persist-data.service';
import { FieldModel } from '../models/extraction-models/extraction-models';

@Injectable({
  providedIn: 'root',
})
export class ManualInputChangeService {
  private readonly extractedLocationStoreService = inject(ExtractedLocationStoreService);
  private readonly persistDataService = inject(PersistDataService);
  private readonly highlightService = inject(OcrHighlightService);

  onUserInput(documentId: string | undefined, fieldModel: FieldModel) {
    // inline consolidators are always edited manually and are not sent to training, so we do not
    // want to prevent training data submission in this case (which is done by flagging existing manual changes)
    if (fieldModel.inlineConsolidatorForField) return;

    if (!documentId) return;

    this.extractedLocationStoreService.deleteExtractedLocation(documentId, fieldModel.key);
    this.persistDataService.flagExistingManualChanges(documentId);
    this.highlightService.clearHighlight();
  }
}
